var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, Fragment } from 'react';
import { CommonModal } from '@appspotr/ui-kit';
import { PageContent } from '@project/components/Page';
import { Input, Label, Checkbox } from '../Forms/Fields';
import SelectForModal from '../Forms/Fields/SelectForModal';
import InputRenderer from '../InputRenderer';
import { ModalButtonFooter, FooterButton, ModalContentContainer, } from '../../containers/StructureBuilderPage/styles';
var DEFAULT_VIEWPORT = {
    latitude: 57.698329,
    longitude: 11.9860685,
    zoom: 10,
    bearing: 0,
    pitch: 0,
};
var types = [
    'text',
    'timestamp',
    'number',
    'url',
    'image',
    'file',
    'boolean',
    'location',
    'json',
    'list',
];
var CreateDialog = function (props) {
    var _a = useState(''), key = _a[0], setKey = _a[1];
    var _b = useState(''), initialKey = _b[0], setInitialKey = _b[1];
    var _c = useState(null), type = _c[0], setType = _c[1];
    var _d = useState(''), label = _d[0], setLabel = _d[1];
    var _e = useState({}), value = _e[0], setValue = _e[1];
    var _f = useState(true), isEmptyValue = _f[0], setIsEmptyValue = _f[1];
    var _g = useState(false), now = _g[0], setNow = _g[1];
    useEffect(function () {
        var _a, _b;
        if ((props.logicStateType !== 'newValue' &&
            props.state.id !== '' &&
            props.state.app) ||
            (props.logicStateType === 'newValue' && props.state.key !== '') ||
            (props.logicStateType === 'json' && props.state.key !== '')) {
            setKey(props.state.key);
            setInitialKey(props.state.key);
            setLabel(props.state.label);
            setType({
                value: props.state.type,
                label: props.state.type,
            });
            var defKey = props.state.key;
            if (typeof props.state === 'object' &&
                'value' in props.state &&
                props.state.value !== null) {
                setIsEmptyValue(false);
            }
            if (props.state.type === 'location' && props.state.value) {
                if (!('lat' in props.state.value) && !('lon' in props.state.value)) {
                    setIsEmptyValue(false);
                }
                setValue((_a = {},
                    _a[defKey] = __assign(__assign({}, props.state.value), { viewport: __assign(__assign({}, DEFAULT_VIEWPORT), { latitude: props.state.value.lat, longitude: props.state.value.lon }) }),
                    _a));
            }
            if (props.state.type === 'timestamp' &&
                props.state.value === '${*now*,date}') {
                setNow(true);
            }
            else
                setValue((_b = {}, _b[defKey] = props.state.value, _b));
        }
    }, [props.state, props.logicStateType]);
    var onKeyChange = function (val) {
        var _a;
        setValue((_a = {},
            _a[val] = value[key],
            _a));
        setKey(val);
    };
    var setEmptyValue = function (_a) {
        var target = _a.target;
        if (target.checked)
            setNow(false);
        setIsEmptyValue(target.checked);
        if (target.checked) {
            setValue({});
        }
    };
    return (_jsx(CommonModal, __assign({ width: "700px", height: "600px", active: props.active, title: props.isUpdate
            ? "Update ".concat(props.logicStateType === 'newValue'
                ? 'New value'
                : props.logicStateType)
            : 'Create a new value', hideModal: function () {
            props.setVisibleStateDialog(false);
            props.setSelectedState({});
        }, footer: _jsxs(ModalButtonFooter, { children: [_jsx(FooterButton, __assign({ modalType: "create", onClick: function () {
                        return props.updateState({
                            key: key,
                            type: type === null || type === void 0 ? void 0 : type.value,
                            label: label,
                            value: isEmptyValue ? null : now ? '${*now*,date}' : value[key],
                        });
                    } }, { children: props.isUpdate
                        ? "Update ".concat(props.logicStateType === 'newValue'
                            ? ''
                            : props.logicStateType)
                        : 'Create' })), props.isUpdate &&
                    (props.logicStateType === 'newValue' ||
                        props.logicStateType === 'json') && (_jsx("span", __assign({ style: { marginLeft: '10px' } }, { children: _jsx(FooterButton, __assign({ modalType: "danger", onClick: function () { return props.delete(initialKey); } }, { children: "Delete" })) })))] }), onClick: function () {
            return props.updateState({
                key: key,
                type: type === null || type === void 0 ? void 0 : type.value,
                label: label,
                value: isEmptyValue ? null : now ? '${*now*,date}' : value[key],
            });
        } }, { children: _jsx(PageContent, __assign({ modal: true }, { children: _jsxs(ModalContentContainer, { children: [_jsx(Label, { children: "Key" }), _jsx(Input, { disabled: props.isUpdate &&
                            props.logicStateType !== 'newValue' &&
                            props.logicStateType !== 'json', value: key, onChange: function (_a) {
                            var target = _a.target;
                            return onKeyChange(target.value);
                        } }), _jsxs(Fragment, { children: [_jsx(Label, { children: "Type" }), props.isUpdate &&
                                props.logicStateType !== 'newValue' &&
                                props.logicStateType !== 'json' ? (_jsx(Input, { disabled: true, value: type === null || type === void 0 ? void 0 : type.value, onChange: function (_a) {
                                    var target = _a.target;
                                    return setKey(target.value);
                                } })) : (_jsx(SelectForModal, { margined: true, name: "type", value: type, options: types.map(function (t) { return ({
                                    value: t,
                                    label: t,
                                }); }), onChange: function (option) {
                                    setType(option);
                                    option.value === 'timestamp' && setValue({});
                                } }))] }), _jsx(Label, { children: "Label" }), _jsx(Input, { value: label, onChange: function (_a) {
                            var target = _a.target;
                            return setLabel(target.value);
                        }, disabled: props.isUpdate &&
                            props.logicStateType !== 'newValue' &&
                            props.logicStateType !== 'json' }), (type === null || type === void 0 ? void 0 : type.value) !== 'list' && (_jsxs(Fragment, { children: [_jsx(Label, { children: props.logicStateType === 'newValue'
                                    ? 'value'
                                    : props.logicStateType }), _jsx(Checkbox, { label: "Empty value", checked: isEmptyValue, onChange: setEmptyValue }), (type === null || type === void 0 ? void 0 : type.value) === 'timestamp' && (_jsx(Checkbox, { label: "Current date time", checked: now, onChange: function () {
                                    setNow(!now);
                                    setIsEmptyValue(false);
                                } })), _jsx(InputRenderer, { field: {
                                    type: type === null || type === void 0 ? void 0 : type.value,
                                    name: key,
                                }, files: props.files, sendObject: value, setSendObject: setValue, disabled: isEmptyValue || now })] }))] }) })) })));
};
export default CreateDialog;
